import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { Nexus } from '@tomandco/nexus-api-types';

interface ICheckoutTotalsElement {
    label: string;
    value: number;
    hideCurrency?: boolean;
}

declare module '@tomandco/nexus-api-types' {
    namespace Nexus.Lib.Basket {
        interface Totals {
            reward_points?: number;
            delivery?: number;
        }
    }
}

@Component({
    selector: 'checkout-success-totals-section',
    templateUrl: './checkout-success-totals-section.html',
    standalone: true,
    imports: [NgClass, TranslationModule, PriceComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutSuccessTotalsSectionComponent implements OnInit {
    @Input({
        required: true
    })
    totals!: Nexus.Lib.Basket.Totals;

    totalsForDisplay: ICheckoutTotalsElement[] = [];

    ngOnInit() {
        this.totalsForDisplay = [
            { label: 'Subtotal', value: this.totals.subtotal },
            { label: 'Rewards Coins', value: this.totals.reward_points, hideCurrency: true },
            { label: 'Delivery', value: this.totals.delivery },
            { label: 'Discount', value: this.totals.discount },
            { label: 'Total price', value: this.totals.grand_total }
        ].filter(item => !!item.value) as ICheckoutTotalsElement[];
    }
}
